import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

const emptyErrorMessage = { message: 'Поле не может быть пустым' };

const emailSchema = z
	.string()
	.min(1, emptyErrorMessage)
	.email('Это недействительный адрес электронной почты');

const schema = z.discriminatedUnion('forgot', [
	z.object({
		forgot: z.literal(true),
		email: emailSchema,
	}),
	z.object({
		forgot: z.literal(false),
		email: emailSchema,
		password: z.string().min(1, emptyErrorMessage),
	}),
]);

export const resolver = zodResolver(schema);



// WEBPACK FOOTER //
// src/components/login-form/login-form.schema.js